import React from 'react';
import axios from 'axios'

import styles from './Download.module.scss';

class Download extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      expanded: false,
      error: false,
      submit: false
    }
    this.valueUpdater = this.valueUpdater.bind(this)
    this.expandSubmit = this.expandSubmit.bind(this)
  }

  valueUpdater = field => (event) => {
    let value = event.target.value;

    const newState = {
      ...this.state,
      [field]: value,
    };
    this.setState(newState);
  }
    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
    expandSubmit() {
        const { email } = this.refs

        if(this.state.expanded === false) {
            this.setState({expanded: true})
        } else {
            var emailCheck = this.validateEmail(email.value)

            if ( emailCheck ) {
                var zapUrl = 'https://hooks.zapier.com/hooks/catch/1060428/qamqep/'
                var payload = {
                    "email": email.value
                }
                axios.post(zapUrl, JSON.stringify(payload)).then( res => {
                    if ( res.status == 200 ) {
                        this.setState({ submit: true })
                        this.SaveToDisk(this.props.file.file.url, this.props.file.fileName)
                    }
                    else {
                        this.setState({ error: true })
                    }
                })
            }
        }
    }
    handleSubmit(e) {
        e.preventDefault()
        this.expandSubmit()
    }
    SaveToDisk(fileURL, fileName) {
        // for non-IE
        if (!window.ActiveXObject) {
            var save = document.createElement('a');
            save.href = fileURL;
            save.target = '_blank';
            save.download = fileName || 'unknown';

            var evt = new MouseEvent('click', {
                'view': window,
                'bubbles': true,
                'cancelable': false
            });
            save.dispatchEvent(evt);

            (window.URL || window.webkitURL).revokeObjectURL(save.href);
        }

        // for IE < 11
        else if ( !! window.ActiveXObject && document.execCommand)     {
            var _window = window.open(fileURL, '_blank');
            _window.document.close();
            _window.document.execCommand('SaveAs', true, fileName || fileURL)
            _window.close();
        }
    }
    render() {
        return (
            <div className={styles.Download}>
                <div className={styles.Download__Wrapper}>
                    <h2>Download the Program Details.</h2>
                    <form className={`${styles.Download__Form} ${this.state.expanded && styles.Download__Form__Expanded}`} onSubmit={ (e) => this.handleSubmit(e) }>
                        <div className={`${styles.FormElement} ${this.state.email !== '' ? styles.FormElementActive : ''}`}>
                            <input type="email" id="email-input" name='email' value={this.state.email} onChange={this.valueUpdater('email')} ref="email" />
                            <label htmlFor="email-input">Email Address</label>
                        </div>
                    </form>
                    <a className={styles.Download__Button} onClick={() => this.expandSubmit()}><img src="/images/icon-downarrow-orange.svg" alt="down arrow" /> Download PDF</a>
                    {
                        this.state.error && !this.state.submit &&
                        <p>Something appears to have gone wrong, please contact us directly!</p>
                    }
                </div>
            </div>
        )
    }
}

export default Download;



// WEBPACK FOOTER //
// ./src/components/Program/Download/index.js